import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import SideBarItem from './sidebar-item';
import { signOut } from 'firebase/auth'
import { auth } from '../../firebase'
import { setAuthToken } from '../../helpers/setAuthToken';
import './styles.css';
import logo from '../../assets/images/logo_2.png';
import LogoutIcon from '../../assets/icons/logout.svg';

function SideBar ({ menu }) {
    const location = useLocation();
    const navigate = useNavigate();

    const [active, setActive] = useState(1);

    useEffect(() => {
        menu.forEach(element => {
            if (location.pathname === element.path) {
                setActive(element.id);
            }
        });
    }, [location.pathname])

    const __navigate = (id) => {
        setActive(id);
    }

    const handleLogout = () => {
        // Clear localStorage token
        localStorage.removeItem('authToken');
        // Clear axios auth header
        setAuthToken(null);
        // Sign out from Firebase (if needed)
        signOut(auth);
        // Redirect to login or refresh the page
        window.location.reload();
    }

    return(
        <nav className='sidebar'>
            <div className='sidebar-container'>
                <div className='sidebar-logo-container'>
                    <img
                        src={logo}
                        alt="logo" />
                </div>

                <div className='sidebar-container'>
                    <div className='sidebar-items'>
                        {menu.map((item, index) => (
                            <div key={index} onClick={() => __navigate(item.id)}>
                                <SideBarItem
                                    active={item.id === active}
                                    item={item} />
                            </div>
                        ))}
                    </div>

                    <div className='sidebar-footer'>
                        <span onClick={handleLogout} className='sidebar-item-label'>Logout</span>
                        <img
                            onClick={handleLogout}
                            src={LogoutIcon}
                            alt='icon-logout'
                            className='sidebar-item-icon' />
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default SideBar;